/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_External_AllowedInputs */

const en_val_external_allowed = /** @type {(inputs: Val_External_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External Allowed`)
};

const es_val_external_allowed = /** @type {(inputs: Val_External_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externos permitidos`)
};

const fr_val_external_allowed = /** @type {(inputs: Val_External_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externe autorisé`)
};

const de_val_external_allowed = /** @type {(inputs: Val_External_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externe erlaubt`)
};

const ja_val_external_allowed = /** @type {(inputs: Val_External_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外部業者の持ち込み可`)
};

const zh_val_external_allowed = /** @type {(inputs: Val_External_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`允许外部供应商`)
};

const ar_val_external_allowed = /** @type {(inputs: Val_External_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسموح بخدمات خارجية`)
};

const id_val_external_allowed = /** @type {(inputs: Val_External_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksternal Diizinkan`)
};

const it_val_external_allowed = /** @type {(inputs: Val_External_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esterni Ammessi`)
};

const ru_val_external_allowed = /** @type {(inputs: Val_External_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Допускаются внешние подрядчики`)
};

const pt_val_external_allowed = /** @type {(inputs: Val_External_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externo Permitido`)
};

const ko_val_external_allowed = /** @type {(inputs: Val_External_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`외부 업체 허용됨`)
};

/**
* | output |
* | --- |
* | "External Allowed" |
*
* @param {Val_External_AllowedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_external_allowed = /** @type {((inputs?: Val_External_AllowedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_External_AllowedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_external_allowed(inputs)
	if (locale === "es") return es_val_external_allowed(inputs)
	if (locale === "fr") return fr_val_external_allowed(inputs)
	if (locale === "de") return de_val_external_allowed(inputs)
	if (locale === "ja") return ja_val_external_allowed(inputs)
	if (locale === "zh") return zh_val_external_allowed(inputs)
	if (locale === "ar") return ar_val_external_allowed(inputs)
	if (locale === "id") return id_val_external_allowed(inputs)
	if (locale === "it") return it_val_external_allowed(inputs)
	if (locale === "ru") return ru_val_external_allowed(inputs)
	if (locale === "pt") return pt_val_external_allowed(inputs)
	return ko_val_external_allowed(inputs)
});